import ColorSwatchIcon from '../assets/svg/LayerLegends/ColorSwatchIcon'

import LegendLine from '../assets/svg/LayerLegends/LegendLine'
import LegendCross from '../assets/svg/LayerLegends/LegendCross'
import LegendDash from '../assets/svg/LayerLegends/LegendDash'
import LegendATV from '../assets/svg/LayerLegends/LegendATV'
import LegendFullWidth from '../assets/svg/LayerLegends/LegendFullWidth'
import LegendDirtBike from '../assets/svg/LayerLegends/LegendDirtBike'
import LegendHighClearance from '../assets/svg/LayerLegends/LegendHighClearance'

import heavyImg from '../assets/lineStyles/Weight/heavy.svg'
import mediumImg from '../assets/lineStyles/Weight/medium.svg'
import thinImg from '../assets/lineStyles/Weight/thin.svg'

import orderBy from 'lodash-es/orderBy'

export const SIDEBAR_WIDTH = 375
export const TOOLBAR_WIDTH = 72

/*
	#TODO: If we move to TS, a ton of these can be turned into type-checked enums.
	That'd be lovely.
	-- TJC - June 18, 2020
*/
export const SIDEBAR_VIEWS = {
  AboutLocation: 'ABOUT_LOCATION',
  Collection: 'COLLECTION',
  Content: 'CONTENT',
  DataManager: 'DATA_MANAGER',
  Export: 'EXPORT',
  FeatureDetail: 'FEATURE_DETAIL',
  FeatureEditor: 'FEATURE_EDITOR',
  FeatureIconEditor: 'FEATURE_ICON_EDITOR',
  HistoricalImagery: 'HISTORICAL_IMAGERY',
  Help: 'HELP',
  Import: 'IMPORT',
  KeyboardShortcuts: 'KEYBOARD_SHORTCUTS',
  Loader: 'LOADER',
  LayerCategoryDetail: 'LAYER_CATEGORY_DETAIL',
  LayerCategoryList: 'LAYER_CATEGORY_LIST',
  Layers: 'LAYERS',
  Library: 'LIBRARY',
  Saved: 'SAVED',
  SelectedFeatures: 'SELECTED_FEATURES',
  Settings: 'SETTINGS',
  TerrainTools: 'TERRAIN_TOOLS',
  User: 'USER'
}

export const SIDEBAR_SAVED_TABS = {
  Collection: 'HUNTS',
  Content: 'CONTENT',
  Layers: {
    All: 'ALL',
    Favorites: 'FAVORITES',
    Active: 'ACTIVE'
  },
  Library: {
    Layers: 'LAYERS',
    Overlays: 'OVERLAYS'
  }
}

export const MEASURING_TOOLS = {
  DirectLine: 'direct-line',
  Distance: 'distance'
}

export const MAP_LAYER_IDS = {
  basemap: {
    default: 'basemap-imagery',
    hybrid: 'hybrid-basemap-imagery',
    satellite: 'sattelite-basemap-imagery',
    topographic: 'topographic-basemap-imagery'
  },
  content: 'gohunt-stuff',
  contour: 'basemap-contour-content',
  ghost: 'gohunt-ghost',
  gohunt: 'gohunt',
  hillshade: 'basemap-hillshade-content',
  historical: 'historical-imagery',
  overlay: 'gohunt-overlay',
  reference: 'basemap-reference-content',
  search: 'gohunt-search',
  select: 'gohunt-select',
  sketch: 'gohunt-sketch',
  terrainAnalysis: 'gohunt-terrain-analysis'
}

export const TERRAIN_BANDS = {
  Elevation: 0,
  Aspect: 1,
  Slope: 2
}

export const UPLOAD_FILESIZE_LIMIT = {
  bytes: 1024 * 1024 * 10,
  mb: 10
}

export const MAX_ZOOM_LEVELS = 24
export const CLICK_RADIUS_ZOOM_THRESHOLD = 15

export const BASEMAPS = {
  Satellite: 'Satellite',
  Hybrid: 'Hybrid',
  Topographic: 'Topographic'
}

export const ICON_COLOR = {
  Dark: '#202020',
  Light: '#FFFFFF'
}

export const LARGE_DATA_SET_COUNT = {
  Collections: 1000,
  Features: 1000
}

export const DEFAULT_FEATURE_COLOR = 'Orange'

export const FEATURE_COLOR = {
  Orange: {
    hex: '#F37735',
    rgba: [243, 119, 53, 1]
  },
  Green: {
    hex: '#00AA55',
    rgba: [0, 170, 85, 1]
  },
  Sky: {
    hex: '#5AC8FA',
    rgba: [90, 200, 250, 1]
  },
  Blue: {
    hex: '#3366FF',
    rgba: [1, 102, 255, 1]
  },
  Purple: {
    hex: '#563CF1',
    rgba: [96, 60, 241, 1]
  },
  Magenta: {
    hex: '#A021CC',
    rgba: [160, 33, 204, 1]
  },
  Red: {
    hex: '#FF3B30',
    rgba: [255, 59, 48, 1]
  },
  Yellow: {
    hex: '#FFCC00',
    rgba: [255, 204, 0, 1]
  },
  Brown: {
    hex: '#795548',
    rgba: [121, 85, 72, 1]
  },
  Black: {
    hex: '#000000',
    rgba: [0, 0, 0, 1]
  },
  Gray: {
    hex: '#8E8E92',
    rgba: [142, 142, 146, 1]
  },
  White: {
    hex: '#FFFFFF',
    rgba: [255, 255, 255, 1]
  }
}

export const FEATURE_TYPES = {
  Point: 'Point',
  Polyline: 'Line',
  Polygon: 'Polygon',
  Tracks: 'Track'
}

export const COLORS = {
  errorRed: '#FF3B30',
  ghOrange: '#F37735',
  ghSilver: '#D0D5D8',
  ghSilverLt: '#E3E3E3',
  ghGreyLtText: '#888888',
  ghGreen: 'rgba(0, 170, 85, 1)',
  ghSecondaryText: '#8e8e92'
}

export const FILE_UPLOAD_STATUS = {
  Uploading: 'Uploading',
  UploadError: 'UploadError',
  UploadProcessing: 'UploadProcessing',
  UploadFinished: 'UploadFinished',
  None: 'None'
}

export const MAP_MODES = {
  TwoD: '2D',
  ThreeD: '3D'
}

export const MAP_VIEW_PROPS = {
  background: {
    color: [26, 26, 27, 1], // '#1a1a1b'
    colors: [
      [51, 88, 55], // '#335837'
      [62, 76, 50], // '#3e4c32'
      [63, 82, 54], // '#3f5236'
      [73, 59, 48], // '#493b30'
      [85, 58, 52], // '#553a33'
      [90, 80, 44], // '#5a502c'
      [106, 151, 66], // '#6a9742'
      [114, 125, 47], // '#727d2f'
      [168, 139, 47], // '#a88b2f'
      [179, 134, 33], // '#b38621'
      [202, 219, 177] // '#cadbb1'
    ]
  }
}

/*
	#NOTE: Could also comment out these states in STATES_DATA itself, but it might have a side-effect, because
	STATES_DATA is also used in Filters. When, we're no longer hiding states, remove HIDDEN_STATES_FOR_LAYERS and
	related code
	-- KD - July 28, 2020
*/
export const HIDDEN_STATES_FOR_LAYERS = ['Alaska', 'Kansas']

export const STATES_DATA = {
  Alabama: {
    abbrev: 'AL',
    center: [-86.8178, 32.7549]
  },
  Alaska: {
    abbrev: 'AK',
    center: [-150.9653, 64.7644]
  },
  Arizona: {
    abbrev: 'AZ',
    center: [-111.6602, 34.2857]
  },
  Arkansas: {
    abbrev: 'AR',
    center: [-92.4397, 34.8901]
  },
  California: {
    abbrev: 'CA',
    center: [-119.2585, 36.311]
  },
  Colorado: {
    abbrev: 'CO',
    center: [-105.5281, 38.9921]
  },
  Connecticut: {
    abbrev: 'CT',
    center: [-72.7359, 41.5718]
  },
  Delaware: {
    abbrev: 'DE',
    center: [-75.4664, 39.0046]
  },
  Florida: {
    abbrev: 'FL',
    center: [-81.6786, 28.5484]
  },
  Georgia: {
    abbrev: 'GA',
    center: [-83.4316, 32.6385]
  },
  Hawaii: {
    abbrev: 'HI',
    center: [-157.9206, 21.3493]
  },
  Idaho: {
    abbrev: 'ID',
    center: [-114.6497, 44.3709]
  },
  Illinois: {
    abbrev: 'IL',
    center: [-89.1419, 40.1066]
  },
  Indiana: {
    abbrev: 'IN',
    center: [-86.2896, 39.9104]
  },
  Iowa: {
    abbrev: 'IA',
    center: [-93.4918, 42.0611]
  },
  Kansas: {
    abbrev: 'KS',
    center: [-98.3816, 38.4724]
  },
  Kentucky: {
    abbrev: 'KY',
    center: [-85.2759, 37.4997]
  },
  Louisiana: {
    abbrev: 'LA',
    center: [-91.4261, 30.1719]
  },
  Maine: {
    abbrev: 'ME',
    center: [-69.212, 45.3123]
  },
  Maryland: {
    abbrev: 'MD',
    center: [-76.1515, 38.8125]
  },
  Massachusetts: {
    abbrev: 'MA',
    center: [-71.7157, 42.3492]
  },
  Michigan: {
    abbrev: 'MI',
    center: [-84.1493, 44.0889]
  },
  Minnesota: {
    abbrev: 'MN',
    center: [-94.2208, 46.3234]
  },
  Mississippi: {
    abbrev: 'MS',
    center: [-89.6445, 32.7136]
  },
  Missouri: {
    abbrev: 'MO',
    center: [-92.4798, 38.3511]
  },
  Montana: {
    abbrev: 'MT',
    center: [-109.6415, 47.0077]
  },
  Nebraska: {
    abbrev: 'NE',
    center: [-99.8055, 41.5232]
  },
  Nevada: {
    abbrev: 'NV',
    center: [-116.6611, 39.3538]
  },
  'New Hampshire': {
    abbrev: 'NH',
    center: [-71.573, 43.6784]
  },
  'New Jersey': {
    abbrev: 'NJ',
    center: [-74.7188, 39.6035]
  },
  'New Mexico': {
    abbrev: 'NM',
    center: [-106.0877, 34.4215]
  },
  'New York': {
    abbrev: 'NY',
    center: [-74.0069, 40.7135]
  },
  'North Carolina': {
    abbrev: 'NC',
    center: [-79.1781, 35.5363]
  },
  'North Dakota': {
    abbrev: 'ND',
    center: [-100.4722, 47.4436]
  },
  Ohio: {
    abbrev: 'OH',
    center: [-82.7064, 40.4046]
  },
  Oklahoma: {
    abbrev: 'OK',
    center: [-97.4931, 35.5684]
  },
  Oregon: {
    abbrev: 'OR',
    center: [-120.5511, 43.9243]
  },
  Pennsylvania: {
    abbrev: 'PA',
    center: [-77.839, 40.8823]
  },
  'Rhode Island': {
    abbrev: 'RI',
    center: [-71.45, 41.4865]
  },
  'South Carolina': {
    abbrev: 'SC',
    center: [-80.8904, 33.894]
  },
  'South Dakota': {
    abbrev: 'SD',
    center: [-100.2348, 44.4269]
  },
  Tennessee: {
    abbrev: 'TN',
    center: [-86.3368, 35.8209]
  },
  Texas: {
    abbrev: 'TX',
    center: [-99.3209, 31.4242]
  },
  Utah: {
    abbrev: 'UT',
    center: [-111.6728, 39.3282]
  },
  Vermont: {
    abbrev: 'VT',
    center: [-72.6633, 44.069]
  },
  Virginia: {
    abbrev: 'VA',
    center: [-78.7018, 37.5121]
  },
  Washington: {
    abbrev: 'WA',
    center: [-120.3931, 47.3625]
  },
  'West Virginia': {
    abbrev: 'WV',
    center: [-80.6076, 38.6193]
  },
  Wisconsin: {
    abbrev: 'WI',
    center: [-89.7314, 44.6322]
  },
  Wyoming: {
    abbrev: 'WY',
    center: [-107.5561, 42.9932]
  }
}

export const USER_ROLES = {
  administrator: 'administrator',
  business_member: 'business_member',
  customer_service: 'customer_service',
  editor: 'editor',
  explorer_trial: 'explorer_trial',
  explorer: 'explorer',
  guest: 'guest',
  insider_plus: 'insider_plus',
  insider_trial: 'insider_trial',
  insider: 'insider',
  maps_pro_trial: 'maps_pro_trial',
  maps_pro: 'maps_pro',
  registered: 'registered',
  rewards: 'gear_rewards'
}

export const LAYER_LEGENDS = {
  'government land': [
    { name: 'Bureau of Land Management', color: '#FFCC00', icon: ColorSwatchIcon },
    { name: 'United States Forest Service', color: '#4F973F', icon: ColorSwatchIcon },
    { name: 'National Park Service', color: '#A021CC', icon: ColorSwatchIcon },
    { name: 'Fish and Wildlife Service', color: '#d99f3a', icon: ColorSwatchIcon },
    { name: 'Wildlife Management Area', color: '#569488', icon: ColorSwatchIcon },
    { name: 'State', color: '#5292DF', icon: ColorSwatchIcon },
    { name: 'Local', color: '#E77272', icon: ColorSwatchIcon },
    { name: 'Tribal', color: '#CC4F5A', icon: ColorSwatchIcon },
    { name: 'Department of Defense', color: '#B15521', icon: ColorSwatchIcon },
    { name: 'Department of Energy', color: '#9A8D5C', icon: ColorSwatchIcon },
    { name: 'Department of the Army', color: '#8E7EED', icon: ColorSwatchIcon },
    { name: 'United States of America', color: '#FBBF70', icon: ColorSwatchIcon },
    { name: 'Agricultural Research Service', color: '#89B4E8', icon: ColorSwatchIcon },
    { name: 'United States Army Corps of Engineers', color: '#64541E', icon: ColorSwatchIcon },
    { name: 'Bureau of Reclamation', color: '#668187', icon: ColorSwatchIcon },
    { name: 'Other', color: '#DAC5A9', icon: ColorSwatchIcon }
  ],
  'public land': [
    { name: 'BLM', color: '#FFCC00', icon: ColorSwatchIcon },
    { name: 'USFS', color: '#4F973F', icon: ColorSwatchIcon },
    { name: 'NPS', color: '#A021CC', icon: ColorSwatchIcon },
    { name: 'FWS', color: '#d99f3a', icon: ColorSwatchIcon },
    { name: 'Wildlife Management Area', color: '#569488', icon: ColorSwatchIcon },
    { name: 'State', color: '#5292DF', icon: ColorSwatchIcon },
    { name: 'Local', color: '#E77272', icon: ColorSwatchIcon },
    { name: 'Tribal', color: '#CC4F5A', icon: ColorSwatchIcon },
    { name: 'DOD', color: '#B15521', icon: ColorSwatchIcon },
    { name: 'DOE', color: '#9A8D5C', icon: ColorSwatchIcon },
    { name: 'DOA', color: '#8E7EED', icon: ColorSwatchIcon },
    { name: 'USA', color: '#FBBF70', icon: ColorSwatchIcon },
    { name: 'ARS', color: '#89B4E8', icon: ColorSwatchIcon },
    { name: 'USACE', color: '#64541E', icon: ColorSwatchIcon },
    { name: 'BOR', color: '#668187', icon: ColorSwatchIcon },
    { name: 'Other', color: '#DAC5A9', icon: ColorSwatchIcon }
  ],
  /* Removed for new layer implementation - April 22, 2022  */
  // 'wilderness': [
  //   {name: 'BLM', color: '#FFCC00', icon: ColorSwatchIcon},
  //   {name: 'USFS', color: '#4F973F', icon: ColorSwatchIcon},
  //   {name: 'NPS', color: '#A021CC', icon: ColorSwatchIcon},
  //   {name: 'FWS', color: '#d99f3a', icon: ColorSwatchIcon},
  //   {name: 'Other', color: '#DAC5A9', icon: ColorSwatchIcon},
  // ],
  /* "mvum" & "motorized" roads and trails are one in the same. Remove after new layer implementation is complete May 4th, 2022 */
  'forest service mvum roads and trails': [
    { name: 'Full-size Vehicle Yearlong', color: '#4ce600', icon: LegendLine },
    { name: '50" ATV or Less Yearlong', color: '#4ce600', icon: LegendCross },
    { name: 'Dirt Bike Yearlong', color: '#4ce600', icon: LegendDash },
    { name: 'Full-size Vehicle Seasonal', color: '#fbd70d', icon: LegendLine },
    { name: '50" ATV or Less Seasonal', color: '#fbd70d', icon: LegendCross },
    { name: 'Dirt Bike Seasonal', color: '#fbd70d', icon: LegendDash },
    { name: 'Closed Roads', color: '#ff5d54', icon: LegendLine }
  ],
   // Deprecated
  // 'motorized roads and trails': [
	// 	{ name: 'Full-size Vehicle Yearlong', color: '#4ce600', icon: LegendLine },
	// 	{ name: '50" ATV or Less Yearlong', color: '#4ce600', icon: LegendCross },
	// 	{ name: 'Dirt Bike Yearlong', color: '#4ce600', icon: LegendDash },
	// 	{ name: 'Full-size Vehicle Seasonal', color: '#fbd70d', icon: LegendLine },
	// 	{ name: '50" ATV or Less Seasonal', color: '#fbd70d', icon: LegendCross },
	// 	{ name: 'Dirt Bike Seasonal', color: '#fbd70d', icon: LegendDash },
	// 	{ name: 'Closed Roads', color: '#ff5d54', icon: LegendLine },
	// ],
   // Change to "motorized roads and trails" after new layer implementation passes qa
  'motorized roads and trails': [
    { name: 'Full Width', color: '#4ce600', icon: LegendFullWidth },
    { name: 'High Clearance', color: '#4ce600', icon: LegendHighClearance },
    { name: 'ATV', color: '#4ce600', icon: LegendATV },
    { name: 'Dirt Bike', color: '#4ce600', icon: LegendDirtBike }
  ]
}

/*
	#TODO: May not need these in this file. Might go better with their
	respective components.
	-- TJC - May 04, 2020
*/
export const SORT_METHODS = {
  ghType: 'Content type',
  updatedAt: 'Last modified',
  title: 'Name (A-Z)',
  createdAt: 'Recently created'
}

export const FEATURE_FILTERS = {
  Point: 'Waypoints',
  Polygon: 'Areas',
  Line: 'Lines',
  Track: 'Tracks'
}

export const ARCGIS_LAYER_VERSION_TAG = process.env.NODE_ENV == 'development' ? '' : ''

export const DEFAULT_LAYER_OPACITY = 1.0

/*
	#TODO: Not used yet, but most likely to be used to map keys to
	actual icons down the line. This first fix is just to get everything
	in sync with each other front end.
	-- TJC - May 18, 2020
*/
export const ICON_DISPLAY_MAP = {
  'antlerless-deer': 'Doe',
  'big-horn-sheep': 'Sheep',
  'black-bear': 'Black Bear',
  'elk-cow': 'Cow Elk',
  'food-plot': 'Food Plot',
  'food-source': 'Food Source',
  'gohunt-logo': 'Waypoint',
  'grizzly-bear': 'Grizzly Bear',
  'ground-blind': 'Ground Blind',
  'ladder-stand': 'Ladder Stand',
  'mountain-goat': 'Mtn Goat',
  'mountain-lion': 'Mtn Lion',
  'mule-deer': 'Buck',
  'pinch-point': 'Pinch Point',
  'point-of-interest': 'Point Of Interest',
  'trail-cam': 'Trail Cam',
  'tree-stand': 'Tree Stand',
  'turkey-dusting': 'Turkey Dusting',
  'turkey-gobble': 'Turkey Gobble',
  'turkey-hen': 'Turkey Hen',
  'turkey-jake': 'Turkey Jake',
  'turkey-roost': 'Turkey Roost',
  'turkey-scat': 'Turkey Scat',
  'turkey-scratch': 'Turkey Scratch',
  'turkey-strut': 'Turkey Strut',
  'turkey-tom': 'Turkey Tom',
  'turkey-track': 'Turkey Track',
  'whitetail-deer': 'Whitetail Deer',
  access: 'Access',
  antelope: 'Antelope',
  arrow: 'Arrow',
  atv: 'ATV',
  bedding: 'Bedding',
  bench: 'Bench',
  bike: 'Bike',
  bison: 'Bison',
  // blind: 'Blind',
  blood: 'Blood',
  boat: 'Boat',
  boots: 'Boots',
  cabin: 'Cabin',
	coyote: 'Coyote',
  camp: 'Camp',
  caribou: 'Caribou',
  caution: 'Hazard',
  chukar: 'Chukar',
  crossing: 'Crossing',
  dog: 'Dog',
  duck: 'Duck',
  elk: 'Elk',
  fish: 'Fish',
  fishing: 'Fishing',
  food: 'Food',
  gate: 'Gate',
  gear: 'Gear',
  glassing: 'Glassing',
  goose: 'goose',
  grouse: 'Grouse',
  horse: 'Horse',
  javelina: 'Javelina',
  junction: 'Junction',
  llama: 'Llama',
  moose: 'Moose',
  mushrooms: 'Mushrooms',
  pack: 'Pack',
  parking: 'Parking',
  pheasant: 'Pheasant',
  photo: 'Photo',
  quail: 'Quail',
  rub: 'Rub',
  saddle: 'Saddle',
  sasquatch: 'Sasquatch',
  scat: 'Scat',
  scrape: 'Scrape',
  shed: 'Shed',
  shot: 'Shot',
  tracks: 'Tracks',
  trail: 'Trail',
  truck: 'Truck',
  vehicle: 'Vehicle',
  wallow: 'Wallow',
  water: 'Water',
  wolf: 'Wolf',

  // misc
  'see-all': 'See All'
}
export const ICON_LIST = orderBy(
  [
    { category: 'Gear', display: 'Arrow', key: 'arrow', order: 1 },
    { category: 'Gear', display: 'Boots', key: 'boots', order: 2 },
    { category: 'Gear', display: 'Camp', key: 'camp', order: 3 },
    { category: 'Gear', display: 'Food', key: 'food', order: 4 },
    { category: 'Gear', display: 'Gear', key: 'gear', order: 5 },
    {
      category: 'Gear',
      display: 'Ground Blind',
      key: 'ground-blind',
      order: 6
    },
    { category: 'Gear', display: 'Pack', key: 'pack', order: 7 },
    {
      category: 'Gear',
      display: 'Trail Cam',
      key: 'trail-cam',
      order: 8
    },
    {
      category: 'Gear',
      display: 'Tree Stand',
      key: 'tree-stand',
      order: 9
    },
    { category: 'Gear', display: 'Water', key: 'water', order: 10 },
    {
      category: 'Navigation',
      display: 'Access',
      key: 'access',
      order: 11
    },
    { category: 'Navigation', display: 'Cabin', key: 'cabin', order: 12 },
    { category: 'Navigation', display: 'Gate', key: 'gate', order: 13 },
    {
      category: 'Navigation',
      display: 'Glassing',
      key: 'glassing',
      order: 14
    },
    {
      category: 'Navigation',
      display: 'Hazard',
      key: 'caution',
      order: 15
    },
    {
      category: 'Navigation',
      display: 'Junction',
      key: 'junction',
      order: 16
    },
    {
      category: 'Navigation',
      display: 'Parking',
      key: 'parking',
      order: 17
    },
    { category: 'Navigation', display: 'Photo', key: 'photo', order: 18 },
    { category: 'Navigation', display: 'Shot', key: 'shot', order: 19 },
    { category: 'Navigation', display: 'Trail', key: 'trail', order: 20 },
    {
      category: 'Navigation',
      display: 'Waypoint',
      key: 'gohunt-logo',
      order: 21
    },
    { category: 'Signs', display: 'Bedding', key: 'bedding', order: 22 },
    { category: 'Signs', display: 'Bench', key: 'bench', order: 23 },
    { category: 'Signs', display: 'Blood', key: 'blood', order: 24 },
    {
      category: 'Signs',
      display: 'Crossing',
      key: 'crossing',
      order: 25
    },
    {
      category: 'Signs',
      display: 'Food Plot',
      key: 'food-plot',
      order: 26
    },
    {
      category: 'Signs',
      display: 'Food Source',
      key: 'food-source',
      order: 27
    },
    {
      category: 'Signs',
      display: 'Ladder Stand',
      key: 'ladder-stand',
      order: 28
    },
    {
      category: 'Signs',
      display: 'Mushrooms',
      key: 'mushrooms',
      order: 29
    },
    {
      category: 'Signs',
      display: 'Pinch Point',
      key: 'pinch-point',
      order: 30
    },
    {
      category: 'Signs',
      display: 'Point Of Interest',
      key: 'point-of-interest',
      order: 31
    },
    { category: 'Signs', display: 'Rub', key: 'rub', order: 32 },
    { category: 'Signs', display: 'Saddle', key: 'saddle', order: 33 },
    { category: 'Signs', display: 'Shed', key: 'shed', order: 34 },
    { category: 'Signs', display: 'Tracks', key: 'tracks', order: 35 },
    { category: 'Signs', display: 'Wallow', key: 'wallow', order: 36 },
    {
      category: 'Species',
      display: 'Antelope',
      key: 'antelope',
      order: 37
    },
    { category: 'Species', display: 'Bison', key: 'bison', order: 38 },
    {
      category: 'Species',
      display: 'Black Bear',
      key: 'black-bear',
      order: 39
    },
    { category: 'Species', display: 'Buck', key: 'mule-deer', order: 40 },
    {
      category: 'Species',
      display: 'Caribou',
      key: 'caribou',
      order: 41
    },
    { category: 'Species', display: 'Chukar', key: 'chukar', order: 42 },
    {
      category: 'Species',
      display: 'Cow Elk',
      key: 'elk-cow',
      order: 43
    },
    {
      category: 'Species',
      display: 'Doe',
      key: 'antlerless-deer',
      order: 44
    },
    { category: 'Species', display: 'Dog', key: 'dog', order: 45 },
    { category: 'Species', display: 'Duck', key: 'duck', order: 46 },
    { category: 'Species', display: 'Elk', key: 'elk', order: 47 },
    {
      category: 'Species',
      display: 'Javelina',
      key: 'javelina',
      order: 48
    },
    { category: 'Species', display: 'Coyote', key: 'coyote', order: 49 },
    { category: 'Species', display: 'Fish', key: 'fish', order: 50 },
    {
      category: 'Species',
      display: 'Fishing',
      key: 'fishing',
      order: 51
    },
    { category: 'Species', display: 'Goose', key: 'goose', order: 52 },
    {
      category: 'Species',
      display: 'Grizzly Bear',
      key: 'grizzly-bear',
      order: 53
    },
    { category: 'Species', display: 'Grouse', key: 'grouse', order: 54 },
    { category: 'Species', display: 'Llama', key: 'llama', order: 55 },
    { category: 'Species', display: 'Moose', key: 'moose', order: 56 },
    {
      category: 'Species',
      display: 'Mtn Goat',
      key: 'mountain-goat',
      order: 57
    },
    {
      category: 'Species',
      display: 'Mtn Lion',
      key: 'mountain-lion',
      order: 58
    },
    {
      category: 'Species',
      display: 'Pheasant',
      key: 'pheasant',
      order: 59
    },
    { category: 'Species', display: 'Quail', key: 'quail', order: 60 },
    {
      category: 'Species',
      display: 'Sasquatch',
      key: 'sasquatch',
      order: 61
    },
    { category: 'Species', display: 'Scat', key: 'scat', order: 62 },
    { category: 'Species', display: 'Scrape', key: 'scrape', order: 63 },
    {
      category: 'Species',
      display: 'Sheep',
      key: 'big-horn-sheep',
      order: 64
    },
    {
      category: 'Species',
      display: 'Turkey Dusting',
      key: 'turkey-dusting',
      order: 65
    },
    {
      category: 'Species',
      display: 'Turkey Gobble',
      key: 'turkey-gobble',
      order: 66
    },
    {
      category: 'Species',
      display: 'Turkey Hen',
      key: 'turkey-hen',
      order: 67
    },
    {
      category: 'Species',
      display: 'Turkey Jake',
      key: 'turkey-jake',
      order: 68
    },
    {
      category: 'Species',
      display: 'Turkey Roost',
      key: 'turkey-roost',
      order: 69
    },
    {
      category: 'Species',
      display: 'Turkey Scat',
      key: 'turkey-scat',
      order: 70
    },
    {
      category: 'Species',
      display: 'Turkey Scratch',
      key: 'turkey-scratch',
      order: 71
    },
    {
      category: 'Species',
      display: 'Turkey Strut',
      key: 'turkey-strut',
      order: 72
    },
    {
      category: 'Species',
      display: 'Turkey Tom',
      key: 'turkey-tom',
      order: 73
    },
    {
      category: 'Species',
      display: 'Turkey Track',
      key: 'turkey-track',
      order: 74
    },
    {
      category: 'Species',
      display: 'Whitetail Deer',
      key: 'whitetail-deer',
      order: 75
    },
    { category: 'Species', display: 'Wolf', key: 'wolf', order: 76 },
    { category: 'Vehicle', display: 'ATV', key: 'atv', order: 77 },
    { category: 'Vehicle', display: 'Bike', key: 'bike', order: 78 },
    { category: 'Vehicle', display: 'Boat', key: 'boat', order: 79 },
    { category: 'Vehicle', display: 'Horse', key: 'horse', order: 80 },
    { category: 'Vehicle', display: 'Truck', key: 'truck', order: 81 },
    {
      category: 'Vehicle',
      display: 'Vehicle',
      key: 'vehicle',
      order: 82
    }
  ],
  ['display'],
  ['asc']
)

export const LAYER_INFO_HIDDEN_KEYS = [
  'create date',
  'created_date',
  'created_user',
  'creationdate',
  'creator',
  'd0 - d4 percentage',
  'd0 percentage',
  'd1 - d4 percentage',
  'd1 percentage',
  'd2 - d4 percentage',
  'd2 percentage',
  'd3 - d4 percentage',
  'd3 percentage',
  'd4 percentage',
  'daily acres',
  'days since create date',
  'days since current date',
  'discovery acres',
  'drought monitor class',
  'drought period',
  'editdate',
  'editor',
  'geographic area coordination center',
  'geographic area coordination center',
  'geometry id',
  'ics209 report date time',
  'incident mgmt organization',
  'incident type category',
  'incident type kind',
  'incidenttypecategory',
  'injuries',
  'irwin id',
  'is valid',
  'last_edited_date',
  'last_edited_user',
  'local incident id',
  'mgmt complexity',
  'nothing percentage',
  'period end day',
  'period end month',
  'period end year',
  'point of orgin county',
  'point of orgin state',
  'shape__area',
  'shape__length',
  'size',
  'source file location',
  'source filename',
  'source zip filename',
  'st_perimet',
  'unique fire identifier',
  'unit id'
]

export const ESRI_FIELD_TYPES = {
  Date: 'esriFieldTypeDate',
  Double: 'esriFieldTypeDouble',
  String: 'esriFieldTypeString',
  GlobalID: 'esriFieldTypeGlobalID',
  ObjectID: 'esriFieldTypeOID',
  Integer: 'esriFieldTypeInteger'
}

export const ONE_METER_TO_FEET = 3.281

export const URL_HASH_TAGS = {
  SHARE_TAG: {
    begin: 'share-token=',
    end: '/'
  }
}

export const ONE_SQ_METER_TO_ACRE = 0.000247105

export const MAP_TOOLS = {
  ElevationProfile: 'ElevationProfile',
  Measure: 'Measure',
  Select: 'Select',
  Sketch_Point: 'Sketch_Point',
  Sketch_Polygon: 'Sketch_Polygon',
  Sketch_Polyline: 'Sketch_Polyline'
}

export const EXPORT_TYPE = {
  GPX: 'gpx',
  KML: 'kml'
}

export const WEIGHT_OPTIONS = [
  { name: 'Thin', image: thinImg, value: 2 },
  { name: 'Medium', image: mediumImg, value: 4 },
  { name: 'Heavy', image: heavyImg, value: 8 }
].map(({ name, image, value }) => ({ key: name, name, value: value, text: name, image }))

export const MAX_ACTIVE_LAYERS = 500
export const MAX_RECENT_LAYERS = 500
export const MAX_RECENT_STYLES = 3

export const COORD_TYPES = {
  basemap: 'BASEMAP',
  dd: 'DD',
  ddm: 'DDM',
  dms: 'DMS',
  iso6709: 'ISO 6709',
  mgrs: 'MGRS',
  usng: 'USNG',
  utm: 'UTM',
  xy: 'XY'
}

export const NOTEABLE_TYPES = {
  Collection: 'collections',
  Feature: 'features'
}

export const MEMBERSHIP_PLANS = [
  { code: 'explorer', name: 'Explorer', price: 49.99 },
  { code: 'insider', name: 'INSIDER', price: 149.99 }
]

export const HISTORICAL_LAYER_IDS = {
  contour: 'historical-contour',
  current: 'historical-current',
  reference: 'historical-reference'
}

export const CONTAINER_IDS = {
  sidebarBody: 'sidebarBody',
  map: 'map-div'
}

export const IMAGERY_METADATA_FIELDS = ['NICE_DESC', 'SRC_ACC', 'SRC_DATE2', 'SRC_DESC', 'SRC_RES']

export const LIMITED_ACCESS_ROLES = ['registered', 'rewards']
